<pr-form (onSubmit)="submit()" [title]="title" [formGroup]="form">
  <pr-input [label]="'Dénomination sociale'" [derrors]="derrors"
    ><input formControlName="name" type="text" [required]="true"
  /></pr-input>
  <pr-input [label]="'Email'" [derrors]="derrors"
    ><input formControlName="email" type="email"
  /></pr-input>

  <pr-input label="Forme juridique" [derrors]="derrors">
    <mat-select formControlName="legalForm">
      <mat-option>Aucune</mat-option>
      @for (legalForm of companyLegalForms; track legalForm) {
        <mat-option [value]="legalForm.id">
          {{ legalForm.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Régime fiscal" [derrors]="derrors">
    <mat-select formControlName="taxSystem">
      <mat-option>Aucun</mat-option>
      @for (taxSystem of companyTaxSystems; track taxSystem) {
        <mat-option [value]="taxSystem.value">
          {{ taxSystem.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input [label]="'Code SIRET'" [derrors]="derrors"
    ><input formControlName="codeSiret" type="text"
  /></pr-input>
  <pr-input [label]="'Numéro immatriculation RCS'" [derrors]="derrors"
    ><input formControlName="rcs" type="text"
  /></pr-input>
  <pr-input [label]="'Lieu d\'immatriculation RCS'" [derrors]="derrors"
    ><input formControlName="lieuImmatriculationRcs" type="text"
  /></pr-input>
  <pr-input [label]="'Code APE'" [derrors]="derrors"
    ><input formControlName="codeAPE" type="text"
  /></pr-input>
  <pr-input-radio
    formControlName="societeCotee"
    label="Société côtée ?"
  ></pr-input-radio>
  @if (form.get('societeCotee').value) {
    <pr-input [label]="'Société côtée sur quel marché ?'" [derrors]="derrors"
      ><input formControlName="societeCoteeMarche" type="text"
    /></pr-input>
  }

  <pr-input label="Secteur d’activité" [derrors]="derrors">
    <mat-select formControlName="activitySector">
      <mat-option>Aucun</mat-option>
      @for (
        companyActivitySector of companyActivitySectors;
        track companyActivitySector
      ) {
        <mat-option [value]="companyActivitySector.id">
          {{ companyActivitySector.value }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Représentant légal" [derrors]="derrors">
    <input formControlName="representative" type="text" />
  </pr-input>

  <pr-input label="Fonction du représentant légal" [derrors]="derrors">
    <mat-select formControlName="representativeFunction">
      @for (
        representativeOption of representativeOptions;
        track representativeOption
      ) {
        <mat-option [value]="representativeOption.value">
          {{ representativeOption.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <h3>Bénéficiaires effectifs</h3>

  <pr-color-panel [display]="allocationPanel.display">
    <pr-panel-body clazz="pam">
      <pr-label [name]="allocationPanel.icon" [width]="18" [height]="18">{{
        allocationPanel.text
      }}</pr-label>
    </pr-panel-body>
  </pr-color-panel>

  <pr-table-form
    #tableForm
    [formGroup]="form.get('beneficialOwner')"
    [addButtonLabel]="'Ajouter un bénéficiaire effectif'"
    swiperMinWidth="768"
    [columnsDefinition]="columnsDefinition"
    [formatTable]="formatTableDataFunction()"
    (deleteItem)="onDeleteItem($event)"
    (onSelectClick)="newOptionLogic()"
    [createModelDefinition]="createModel.bind(this)"
  >
  </pr-table-form>

  <h3 class="mtm">Adresses</h3>

  <pr-input-map
    (placeChanged)="toValue = $event"
    placeholder="Enter to address..."
    label="Adresse du siège social"
    formGroupName="addressSiegeSocial"
    [isGMaps]="true"
    [countries]="countries"
    [derrors]="derrors"
  >
  </pr-input-map>
  <pr-input-map
    (placeChanged)="toValue = $event"
    placeholder="Enter to address..."
    label="Adresse du siège administratif"
    formGroupName="addressSiegeAdministratif"
    [isGMaps]="true"
    [countries]="countries"
    [derrors]="derrors"
  >
  </pr-input-map>

  <h3>Chiffres N-1</h3>

  <pr-input [label]="'Chiffre d’affaires '" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanCAN1" type="text"
  /></pr-input>
  <pr-input [label]="'Total du bilan'" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanTotalBilanN1" type="text"
  /></pr-input>
  <pr-input [label]="'Montant IR/IS payé'" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanTaxN1" type="text"
  /></pr-input>
  <pr-input
    [label]="'Résultat de l’exercice'"
    [suffix]="'€'"
    [derrors]="derrors"
    ><input formControlName="bilanNetResultN1" type="text"
  /></pr-input>
  <pr-input [label]="'Trésorerie stable'" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanTresoryN1" type="text" />
  </pr-input>
  <pr-input [label]="'Dette financière'" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanDebtN1" type="text"
  /></pr-input>
  <pr-input [label]="'Fond propres'" [suffix]="'€'" [derrors]="derrors"
    ><input formControlName="bilanEquityN1" type="text"
  /></pr-input>
</pr-form>
